export default __webpack_public_path__ + "static/media/fede.eb1e05bc.png";